export const EARMARK_ICONS = [
  {
    contains: 'retirement',
    icon: 'fas fa-island-tropical',
  },
  {
    contains: 'buy a car',
    icon: 'far fa-car',
  },
  {
    contains: 'education',
    icon: 'far fa-graduation-cap',
  },
  {
    contains: 'homepurchase',
    icon: 'far fa-home-lg',
  },
  {
    contains: 'emergencyfund',
    icon: 'far fa-life-ring',
  },
  {
    contains: 'healthcare',
    icon: 'far fa-hands-heart',
  },
];
export const ALL_GOALS = 'allgoals';
export const FALLBACK_ICON = 'fa fa-dollar-sign';
